import { IoChatbubbleOutline, IoMailOutline } from "react-icons/io5";
import { CiLocationOn } from "react-icons/ci";
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";
const Footer = () => {
    return (
        <>
            <div className="bg-[#292E31]">
                <div className="max-w-screen-xl mx-auto px-3">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7  py-20">
                        <div>
                            <h1 className="text-gray-100 text-xl mb-5">About Us</h1>
                            <hr className="pb-5  border-gray-600" />

                            <p className="text-gray-300 mt-5">Unlock the power of education through the magic of gaming. Our platform is a dynamic hub that bridges the world of game developers, educational institutions, and students. We believe in transforming learning into a thrilling adventure, making education engaging, motivating, and fun.
</p>
                            <h1 className="py-5 text-gray-100 text-xl mt-4">Payments Accepted</h1>
                            <hr className="pb-5  border-gray-600" />
                            <div className=" flex gap-5">
                                <button className="border py-2 px-2 text-gray-300 hover:text-gray-200">Paypal</button>
                                <button className="border py-2 px-2 text-gray-300 hover:text-gray-200">Visa</button>
                                <button className="border py-2 px-2 text-gray-300 hover:text-gray-200">MasterCard</button>
                            </div>
                        </div>
                        <div >
                            <h1 className="text-gray-100 text-xl mb-5">Contact Info</h1>
                            <hr className="pb-5  border-gray-600" />
                            <p className="flex items-center gap-3 text-gray-300 mb-3">
                                <IoMailOutline className="text-xl"></IoMailOutline>
                                <span className="text-gray-300">
                                    badrul.karim.akib@gmail.com
                                </span>

                            </p>

                            <p className="flex items-center gap-3 text-gray-300 mb-3">
                                <IoChatbubbleOutline className="text-xl"></IoChatbubbleOutline>
                                <span className="text-gray-300">
                                    01711878473
                                </span>

                            </p>
                            <p className="flex items-center gap-3 text-gray-300 mb-8">
                                <CiLocationOn className="text-xl"></CiLocationOn>
                                <span className="text-gray-300">
                                    Dhanmondi, Dhaka
                                </span>

                            </p>

                            <h1 className="text-gray-100 text-xl mb-5">Be Social</h1>
                            <hr className="pb-5  border-gray-600" />
                            <div className="flex items-center gap-3">
                                <div>
                                    <FaFacebookF className="text-gray-600 hover:text-gray-400 text-4xl"></FaFacebookF>
                                </div>
                                <div>
                                    <FaTwitter className="text-gray-600 hover:text-gray-400 text-4xl"></FaTwitter>
                                </div>
                                <div>
                                    <FaInstagram className="text-gray-600 hover:text-gray-400 text-4xl"></FaInstagram>
                                </div>
                            </div>
                        </div>
                        <div>
                            <h1 className="text-gray-100 text-xl mb-5">Recent Posts</h1>
                            <div>
                                <hr className="pb-3  border-gray-600" />
                                <h2 className="text-gray-300 hover:text-gray-200 hover:cursor-pointer">Learning Through Game is Fun!!</h2>
                                <p className="text-gray-400 text-xs mb-3"></p>
                                <hr className="pb-5  border-gray-600" />
                            </div>
                            <div>

                                <h2 className="text-gray-300 hover:text-gray-200 hover:cursor-pointer"> Students are using the phone for learning perpose</h2>
                                <p className="text-gray-400 text-xs mb-3"></p>
                                <hr className="pb-3  border-gray-600" />
                            </div>
                            <div>

                                <h2 className="text-gray-300 hover:text-gray-200 hover:cursor-pointer">Let's Be Billionear</h2>
                                <p className="text-gray-400 text-xs mb-3"></p>
                                <hr className="pb-3  border-gray-600" />
                            </div>
                            <div>

                                <h2 className="text-gray-300 hover:text-gray-200 hover:cursor-pointer">Let's Download the game</h2>
                                <p className="text-gray-400 text-xs mb-3"></p>
                                <hr className="pb-3  border-gray-600" />
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Footer;